import { Factory } from '..'
import { applyEntitySchema, objectSchema, optionalTolerant, sourceJson } from '../../_utils/fcdc-v2'
import * as z from 'zod'

export enum IssueType {
  Dirty = 'dirty',
  Broken = 'broken',
  WrongSize = 'wrongSize',
  Unspecified = 'unspecified',
}

const issueSchema = objectSchema({
  type: optionalTolerant(z.string()),
  note: optionalTolerant(z.string()),
})

const issueReportSchema = objectSchema({
  issue: optionalTolerant(z.unknown()),
  userId: optionalTolerant(z.string()),
  sessionId: optionalTolerant(z.string()),
  created: optionalTolerant(z.union([z.string(), z.number()])),
  type: optionalTolerant(z.string()),
  note: optionalTolerant(z.string()),
})

export class Issue {
  type: IssueType
  note?: string

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.type = source?.type ?? IssueType.Unspecified
    this.note = source?.note
    applyEntitySchema(this, issueSchema, source, { type: IssueType.Unspecified })
  }
}

export class IssueReport {
  issue: Issue
  userId: string
  sessionId?: string
  created: Date

  constructor(json: any) {
    const source = sourceJson(json) as any
    const rawIssue = source.issue ?? { type: source.type, note: source.note }
    this.issue = new Issue(rawIssue)
    this.userId = source.userId
    this.sessionId = source.sessionId
    this.created = new Date(source.created)
    applyEntitySchema(this, issueReportSchema, source, {})
  }

  static getFactory(): Factory<IssueReport> {
    return new (class implements Factory<IssueReport> {
      make(json: any): IssueReport {
        return new IssueReport(json)
      }

      getTableName(): string {
        return 'issue_reports'
      }
    })()
  }
}
